export default __webpack_public_path__ + "static/media/ug.1e3694d5.svg";